import axios from 'axios'
import storage from '@/service/storage-service'
import { isEmbedded } from './embed-mode'
import { reportEmbeddedSession } from './platform-token-bridge'
import router from '@/router/index'
import jquery from 'jquery'
// import { message } from 'ant-design-vue'
import {
  Message
} from 'element-ui'
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.put['Content-Type'] = 'application/json;charset=UTF-8'
const appId = process.env.APP_ID || 'jukun'
axios.defaults.headers.common.AppId = appId
axios.defaults.AppId = appId

// 本地开发由 webpack-dev-server 代理到 8082；生产部署由同域网关代理。
axios.defaults.baseURL = process.env.APP_API_BASE_URL || '/jukun/api'
axios.defaults.base = process.env.APP_ASSET_BASE_URL || '/jukun'

//axios.defaults.imageURL = 'http://yuenisuoxiang.oss-cn-shenzhen.aliyuncs.com'

axios.defaults.paramsSerializer = function (params) {
  if (typeof params == 'object') {
    var paramsCopy = JSON.parse(JSON.stringify(params))
    for (var k in paramsCopy) {
      if (typeof paramsCopy[k] == 'object') {
        paramsCopy[k] = JSON.stringify(paramsCopy[k])
      }
    }
  }
  return jquery.param(paramsCopy)
}
// 请求拦截器
axios.defaults.onReqSuccess = function (config) {
  let currentUser = storage.getUser()
  if (currentUser && currentUser.token) {
    // Axios 实例的请求拦截阶段应直接写最终请求头。写入 headers.common
    // 在部分构建版本中不会被合并，后端收到空 Authorization 后就会返回 userId 为空。
    config.headers = config.headers || {}
    config.headers.Authorization = currentUser.token
    config.headers.token = currentUser.token
    config.headers.AppId = appId
  }
  return config
}
axios.defaults.onReqError = function (error) {
  return Promise.reject(error)
}
axios.defaults.onResSuccess = function (res) {
  if (res.data.errCode) {
    // -3 才是认证失败；-6 是普通的数据为空/数据缺失，不能清除 SSO 会话。
    if (res.data.errCode == -3) {
      if (isEmbedded) reportEmbeddedSession(false)
      console.log(Message)
      Message({
        message: '用户验证失败或登录超时',
        type: 'warning'
      })
      storage.clearSession()
      storage.clear()
      router.push({
        name: 'Login'
      })
    } else {
      Message({
        type: 'error',
        message: '' + res.data.errMsg
      })
    }
  }
  return res.data
}
axios.defaults.onResError = function (error) {
  if (error.response && error.response.status == 401) {
    if (isEmbedded) reportEmbeddedSession(false)
    Message({
      message: '用户验证失败或登录超时',
      type: 'warning'
    })
    storage.clearSession()
    storage.clear()
    router.push({
      name: 'Login'
    })
  } else if (error && (error.code === 'ECONNABORTED' || String(error.message || '').includes('timeout'))) {
    Message({
      message: '监测服务响应较慢，请稍后重试',
      type: 'warning'
    })
  } else {
    Message({
      message: error.message,
      type: 'error'
    })
  }
  return Promise.reject(error)
}

export default axios



// WEBPACK FOOTER //
// ./src/service/http-service.js